import { createApp } from 'vue'
import CardList from './CardList.vue'
// cardlist component
createApp(CardList).mount('#cardlist-component')
